import React, { Component } from 'react';
import './Main.css';
import { Nav, Navbar, Container } from 'react-bootstrap';

import {
    Route,
    BrowserRouter,
    Switch
} from "react-router-dom";
import Home from "./Home";
import Ball from "./Ball";
import NotFound from "./NotFound";
import Policy from "./Policy";
import Help from "./Help";
import Terms from "./Terms";

// import { CookieBanner } from '@palmabit/react-cookie-law';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';


class Main extends Component {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    }

    constructor(props) {
        super(props);

        const { cookies } = props;
        this.state = {
            currentMenuKey: null,
            rclConsentGiven: cookies.get('rcl_consent_given') || false,
            rclPreferencesGiven: cookies.get('rcl_preferences_consent') || false,
            rclStatisticsGiven: cookies.get('rcl_statistics_consent') || false,
            rclMarketingGiven: cookies.get('rcl_marketing_consent') || false,
        }
    }

    handleSelect(key) {
        this.setState({ currentMenuKey: key });
    };

    async componentDidMount() {
        if (process.env.REACT_APP_CUSTOM_NODE_DEV === 'development' || process.env.REACT_APP_CUSTOM_NODE_DEV === 'testing') {
            // if (false) {
            // for debugging
            this.props.cookies.remove('rcl_consent_given');
            this.props.cookies.remove('rcl_preferences_consent');
            this.props.cookies.remove('rcl_statistics_consent');
            this.props.cookies.remove('rcl_marketing_consent');
        }

        // Google Analytics event
        window.gtag('event', "interact", {
            send_to: ['G-R32TQ4L14R'],
            event_category: "search",
            event_action: "land",
            event_label: "referer",
            value: document.referrer
        });
    }

    render() {
        return (
            <BrowserRouter>
                <div className="Main">
                    {/* <Container fluid> */}
                    {/* <Nav fill variant="pills" defaultActiveKey="/" activeKey={this.state.currentMenuKey} className="menu-bar" onSelect={(selectedKey) => this.handleSelect(selectedKey)}> */}
                    {/* <Nav.Item>
                            <Nav.Link href="/" eventKey="h"><img alt="Beadmeer" src={process.env.PUBLIC_URL + '/images/logo192.png'} style={{ height: 36 }} /></Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link href="/about" eventKey="o">About Us</Nav.Link>
                        </Nav.Item> */}
                    {/* <Nav.Item>
                                <Nav.Link disabled></Nav.Link>
                            </Nav.Item> */}
                    {/* </Nav> */}

                    {/* </Container> */}
                    <div className="content">
                        <Switch>
                            <Route exact path="/" component={Home} />
                            <Route path="/search/:keywords/:page?" component={Ball} />
                            <Route path="/policy/:name?" component={Policy} />
                            <Route path="/help/:name?" component={Help} />
                            <Route path="/terms" component={Terms} />
                            <Route component={NotFound} />
                        </Switch>
                        {/* <Route path="/policy/:name?" component={Policy} />
                            <Route path="/terms" component={Terms} /> */}
                    </div>

                    <Container fluid>
                        {/* <Navbar bg="light" fixed="bottom"> */}
                        <Navbar bg="light">
                            <Nav fill variant="pills" activeKey={this.state.currentMenuKey} onSelect={(selectedKey) => this.handleSelect(selectedKey)} style={{ width: '100%' }}>
                                <Nav.Item>
                                    <Nav.Link href="/help" style={{ color: '#111' }} eventKey="h">Help</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link href="/policy/privacy" style={{ color: '#111' }} eventKey="p">Privacy</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link href="/terms" style={{ color: '#111' }} eventKey="t">Terms</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link disabled></Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link disabled></Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link disabled></Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    {/* <Nav.Link disabled style={{ color: '#111' }}><span>BeadMeer&trade; and their logos are trademarks of &#169; 2021, </span><span style={{ color: '#800080' }}>Oeuf Laboratory</span> <span style={{ fontSize: '0.8em', fontStyle: 'italic' }}>by Softopinion Group Corporation</span></Nav.Link> */}
                                    <Nav.Link disabled style={{ color: '#111' }}><span>&#169; 2021-2023 </span><span style={{ color: '#800080' }}>Oeuf Laboratory</span> <span style={{ fontSize: '0.8em', fontStyle: 'italic' }}>by SoftOpinion Group</span></Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </Navbar>
                    </Container>
                </div>
            </BrowserRouter>
        );
    }
}

export default withCookies(Main);
